import { render, staticRenderFns } from "./TableInvStock.vue?vue&type=template&id=4f5562ee&scoped=true"
import script from "./TableInvStock.vue?vue&type=script&lang=js"
export * from "./TableInvStock.vue?vue&type=script&lang=js"
import style0 from "./TableInvStock.vue?vue&type=style&index=0&id=4f5562ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5562ee",
  null
  
)

export default component.exports